<template>
  <div class="maintenanceProjectRecord">
    <div class="function-bar">
      <el-button
        round
        @click="handlePrint"
      >
        <i class="el-icon-printer" style="margin-right: 4px;" />{{ $t('Asset.MaintenanceProjectRecord.Export') }}
      </el-button>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        v-for="item in maintenanceProjectRecordStructure"
        :key="item.key"
        :prop="item.key"
        :label="item.label"
      />
    </el-table>
    <div
      v-if="isLoading"
      class="promptText"
    >
      <div class="spinner">
        <div class="bounce1" />
        <div class="bounce2" />
        <div class="bounce3" />
      </div>
    </div>
    <div class="button-container">
      <el-button
        type="primary"
        @click="backToMaintenance"
      >
        返回維養計畫列表
      </el-button>
    </div>
    <div
      ref="printPage"
      class="print-page"
    >
      <table
        class="print-table"
        aria-describedby="print-plan-name"
      >
        <colgroup>
          <col style="width: 6%">
          <col style="width: 14%">
          <col style="width: 11%">
          <col style="width: 22%">
          <col style="width: 14%">
          <col style="width: 8%">
          <col style="width: 11%">
          <col style="width: 14%">
        </colgroup>
        <thead>
          <tr>
            <th
              id="print-plan-name"
              :colspan="maintenanceProjectRecordStructure.length + 1"
            >
              <div class="print-header">
                <span class="print-plan-name">{{ $t('Asset.MaintenanceProjectRecord.PlanName') }}{{ planName }}</span>
                <span class="print-time">{{ $t('Asset.MaintenanceProjectRecord.ExportDate') }}{{ printTime }}</span>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="col">#</th>
            <th
              v-for="item in maintenanceProjectRecordStructure"
              :key="item.key"
              scope="col"
            >
              {{ item.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in tableData"
            :key="index"
          >
            <td>{{ index + 1 }}</td>
            <td
              v-for="item in maintenanceProjectRecordStructure"
              :key="item.key"
            >
              {{ row[item.key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { apiAsset } from '../../../api/smartBuildingSystemAPI'
import { maintenanceProjectRecordStructure } from '../models'
export default {
  data () {
    return {
      isLoading: true,
      maintenanceProjectRecordStructure,
      tableData: [],
      planName: '',
      printTime: ''
    }
  },
  async mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      try {
        this.isLoading = true
        const planId = this.$route.params.planId
        const [recordRes, planRes] = await Promise.all([
          apiAsset.maintenance.getMaintenancePlanRecordById(planId),
          apiAsset.maintenance.getMaintenancePlanById(planId)
        ])
        this.planName = planRes.data.Name
        const processedData = recordRes.data.map(el => ({
          ...el,
          NextTime: dayjs(el.NextTime).format('YYYY-MM-DD'),
          ReportTime: dayjs(el.ReportTime).format('YYYY-MM-DD'),
          State: el.State === 'done' ? '完成' : '未完成'
        }))
        this.tableData = processedData
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    handlePrint () {
      this.printTime = this.getPrintTime()
      this.$nextTick(() => {
        this.$print(this.$refs.printPage)
      })
    },
    getPrintTime () {
      return dayjs().format('YYYY/MM/DD HH:mm:ss')
    },
    backToMaintenance () {
      this.$router.push({
        name: 'maintenance'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.maintenanceProjectRecord {
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  .promptText {
    margin: 25px 0px 0px 0px;
    font-size: 20px;
    @include LoadingEffect();
  }
}
.function-bar {
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-table {
  @include basicTable();
}
.print-page {
  display: none;
}
</style>
<style lang="scss">
@page {
  size: A4 portrait;
  margin: 0 0 12mm 0;

  @bottom-right {
    content: counter(page) " / " counter(pages);
    font-size: 11px;
    padding-right: 12mm;
    padding-bottom: 4mm;
    color: #000;
  }
}

@media print {
  .print-page {
    display: block !important;
    color: #000;
    width: 100%;
    padding: 0 12mm 12mm 12mm;
    box-sizing: border-box;

    .print-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;

      thead {
        display: table-header-group;

        tr:first-child th {
          padding: 12mm 0 8px 0;
          border: none;

          .print-header {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .print-plan-name {
              font-size: 20px;
              font-weight: bold;
            }

            .print-time {
              font-size: 14px;
            }
          }
        }

        tr:last-child th {
          border: 1px solid #000;
          padding: 8px;
          text-align: center;
          font-size: 13px;
          word-wrap: break-word;
        }
      }

      tbody td {
        border: 1px solid #000;
        padding: 8px;
        font-size: 13px;
        word-wrap: break-word;
      }

      // #、日期、電話、狀態欄位不換行
      tbody td:nth-child(1),
      tbody td:nth-child(2),
      tbody td:nth-child(5),
      tbody td:nth-child(6),
      tbody td:nth-child(8) {
        white-space: nowrap;
      }
    }
  }
}
</style>
